var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeslider6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 4.63158H16.1V2.31579C16.1 1.03053 15.0765 0 13.8 0H9.2C7.9235 0 6.9 1.03053 6.9 2.31579V4.63158H2.3C1.0235 4.63158 0.0115 5.66211 0.0115 6.94737L0 19.6842C0 20.9695 1.0235 22 2.3 22H20.7C21.9765 22 23 20.9695 23 19.6842V6.94737C23 5.66211 21.9765 4.63158 20.7 4.63158ZM13.8 4.63158H9.2V2.31579H13.8V4.63158Z",
    fill: "#47B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeslider6);
export default __webpack_public_path__ + "static/media/homeslider6.566ff1b1046a3797cd92f39072a041ed.svg";
export { ForwardRef as ReactComponent };